var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.6436 12V16.4C15.6436 16.7314 15.375 17 15.0436 17H4.24355C3.91218 17 3.64355 16.7314 3.64355 16.4V7.6C3.64355 7.26863 3.91218 7 4.24355 7H15.0436C15.375 7 15.6436 7.26863 15.6436 7.6V12ZM15.6436 12L20.6595 7.82009C21.0503 7.49443 21.6436 7.77232 21.6436 8.28103V15.719C21.6436 16.2277 21.0503 16.5056 20.6595 16.1799L15.6436 12Z","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Video.defaultProps = {"preserveAspectRatio":"xMinYMin meet","viewBox":"0 0 25 24","fill":"none"};

module.exports = Video;

Video.default = Video;
